import React, { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { useThemeMode } from './hooks/useThemeMode';
import Header from './components/Header/Header';
import Home from './pages/Home';
import { useTranslation } from 'react-i18next';
import './i18n/config';
import Layout from './components/Layout';
import ScrollProgress from './components/ScrollProgress';
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from '@vercel/analytics/react';
import './styles/game.css';

const ThemedApp: React.FC = () => {
  const { mode } = useThemeMode();
  const { i18n } = useTranslation();

  const theme = createTheme({
    palette: {
      mode,
      primary: {
        main: '#2F73EE',
        light: '#69A1FF',
        dark: '#184FAE',
      },
      secondary: {
        main: '#7C5CE4',
        light: '#A995F0',
        dark: '#5737B7',
      },
      background: {
        default: mode === 'light' ? '#EEF5FF' : '#07111F',
        paper: mode === 'light' ? '#FFFFFF' : '#0D1F36',
      },
      text: {
        primary: mode === 'light' ? '#10233F' : '#EEF6FF',
        secondary: mode === 'light' ? '#66809F' : '#8FA8C5',
      },
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    },
  });

  useEffect(() => {
    // Recupera o idioma salvo no localStorage ou usa o padrão do navegador
    const savedLanguage = localStorage.getItem('i18nextLng');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ScrollProgress />
      <Layout>
        <Header />
        <Home />
        <SpeedInsights />
        <Analytics
          beforeSend={(event) => {
            // Adiciona informações adicionais ao evento
            return {
              ...event,
              theme: mode,
              language: i18n.language,
              // Você pode adicionar mais informações personalizadas aqui
            };
          }}
          debug={process.env.NODE_ENV === 'development'}
        />
      </Layout>
    </ThemeProvider>
  );
};

const App: React.FC = () => {
  return (
    <ThemeModeProvider>
      <ThemedApp />
    </ThemeModeProvider>
  );
};

export default App;
